'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CrawlRunData = function (_BaseApi) {
  (0, _inherits3.default)(CrawlRunData, _BaseApi);
  function CrawlRunData() {
    (0, _classCallCheck3.default)(this, CrawlRunData);
    return (0, _possibleConstructorReturn3.default)(this, (CrawlRunData.__proto__ || Object.getPrototypeOf(CrawlRunData)).call(this, _frontendUtils.endpoints.apiBaseUrl + '/maestro'));
  }
  (0, _createClass3.default)(CrawlRunData, [{
    key: 'getCrawlRunsSince',
    value: function getCrawlRunsSince() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        timestamp = _ref.timestamp,
        type = _ref.type;
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString(timestamp))) {
        return Promise.reject(new _ParameterError2.default('timestamp', timestamp, 'string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString(type))) {
        return Promise.reject(new _ParameterError2.default('type', type, 'string.'));
      }
      var queryParameters = {};
      if (timestamp) queryParameters.timestamp = timestamp;
      if (type) queryParameters.type = type;
      return this.makeRequest({
        method: 'GET',
        url: 'crawlRun/since',
        queryParameters: queryParameters
      });
    }
  }, {
    key: 'getRecentlyCompletedCrawlRuns',
    value: function getRecentlyCompletedCrawlRuns() {
      return this.makeRequest({
        method: 'GET',
        url: 'crawlRun/recentlyCompleted'
      });
    }
  }, {
    key: 'getCrawlRunsInProgress',
    value: function getCrawlRunsInProgress() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref2.type;
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString(type))) {
        return Promise.reject(new _ParameterError2.default('type', type, 'string.'));
      }
      var queryParameters = {};
      if (type) queryParameters.type = type;
      return this.makeRequest({
        method: 'GET',
        url: 'crawlRun/inProgress',
        queryParameters: queryParameters
      });
    }
  }, {
    key: 'getCrawlHistory',
    value: function getCrawlHistory(extractorGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun'
      });
    }
  }, {
    key: 'getCrawlRunStatus',
    value: function getCrawlRunStatus(extractorGuid, crawlRunGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(crawlRunGuid)) {
        return Promise.reject(new _ParameterError2.default('crawlRunGuid', crawlRunGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/' + crawlRunGuid
      });
    }
  }, {
    key: 'getCrawlRunData',
    value: function getCrawlRunData(extractorGuid, crawlRunGuid, options) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(crawlRunGuid)) {
        return Promise.reject(new _ParameterError2.default('crawlRunGuid', crawlRunGuid, 'guid string.'));
      }
      // need to do some validations on the options values 
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isObject(options))) {
        return Promise.reject(new _ParameterError2.default('options', options, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/' + crawlRunGuid + '/data',
        queryParameters: options
      });
    }
  }, {
    key: 'getCrawlRunColumns',
    value: function getCrawlRunColumns(extractorGuid, crawlRunGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(crawlRunGuid)) {
        return Promise.reject(new _ParameterError2.default('crawlRunGuid', crawlRunGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/' + crawlRunGuid + '/column'
      });
    }
  }, {
    key: 'getColumn',
    value: function getColumn(extractorGuid, crawlRunGuid, columnId) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(crawlRunGuid)) {
        return Promise.reject(new _ParameterError2.default('crawlRunGuid', crawlRunGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(columnId)) {
        return Promise.reject(new _ParameterError2.default('columnId', columnId, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/' + crawlRunGuid + '/column/' + columnId
      });
    }
  }, {
    key: 'getColumnData',
    value: function getColumnData(extractorGuid, crawlRunGuid, columnId, options) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(crawlRunGuid)) {
        return Promise.reject(new _ParameterError2.default('crawlRunGuid', crawlRunGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(columnId)) {
        return Promise.reject(new _ParameterError2.default('columnId', columnId, 'guid string.'));
      }
      // need to do better options validations

      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isObject(options))) {
        return Promise.reject(new _ParameterError2.default('options', options, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/' + crawlRunGuid + '/column/' + columnId + '/data',
        queryParameters: options
      });
    }
  }, {
    key: 'getLatestCrawlRun',
    value: function getLatestCrawlRun(extractorGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/latest'
      });
    }
  }, {
    key: 'getLatestCrawlRunData',
    value: function getLatestCrawlRunData(extractorGuid, options) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isObject(options))) {
        return Promise.reject(new _ParameterError2.default('options', options, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/latest/data',
        queryParameters: options
      });
    }
  }, {
    key: 'getCrawlRunSentiment',
    value: function getCrawlRunSentiment(extractorGuid, crawlRunGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(crawlRunGuid)) {
        return Promise.reject(new _ParameterError2.default('crawlRunGuid', crawlRunGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/' + crawlRunGuid + '/sentiment'
      });
    }
  }, {
    key: 'getCrawlRunSampleSize',
    value: function getCrawlRunSampleSize(extractorGuid, crawlRunGuid, maxMb) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      if (!ValidationUtils.isGuid(crawlRunGuid)) {
        return Promise.reject(new _ParameterError2.default('crawlRunGuid', crawlRunGuid, 'guid string.'));
      }
      var parameters = {
        method: 'GET',
        url: 'extractor/' + extractorGuid + '/crawlRun/' + crawlRunGuid + '/direct'
      };

      // maxMb defaults to 20 on server side
      if (maxMb) {
        parameters.queryParameters = {
          maxMb: maxMb
        };
      }
      return this.makeRequest(parameters);
    }
  }]);
  return CrawlRunData;
}(_BaseApi3.default);
exports.default = CrawlRunData;